var defaultImg = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIMAAAB9CAYAAACBBdAPAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAASDSURBVHgB7d3bUttGHIDxlVY+yDZgmpDmEXrZdHoB6XQmvFEfqZd9izDTZtqbDrnksi9QMAafdNpoHfTHyeAEO2C8q+8344wUJh4Sf9ZqV3II1I2//vn3UBXhYRCovkItlK/1IDfq/a9Hr07m+/aXP/8+fRMq9UahngJz9svhT38Eb9+e9ptt9ZtCrZUHg9/DVit/qVB7mQl/CI3RbYXa07pohwq4QQwQxABBDBDEAEEMEMQAQQwQxABBDBDEAEEMEMQAQQwQxABBDBDEAEEMEMQAQQwQxABBDBDEAEEMEMQAQQwQxABBDBDEAEEMEMQAQQwQxABBDBDEAEEMEMQAQQwQxABBDBDEABEpD41Go8b1eNRUTyQMQvPd/v5Ea22UQ7yLwRgTDIaXT/5fIJ9fXMQHz5+PlUO8GyayogjUFijMdnwfq/BymFh08OyZvDsvh1etJE203e52e0mn3crUGhafp9PppN04Tu12Mkv05fVVSznK+xiazVZ+u3d1+/tRlH/6tVXcPo8OdVE9T5rnTh9pmU1AeH9keGx5kYdJMpsPGWmaOf3m8i6GKAzN4nnCov7+/tTk2fzETjeahXoA4/G4YR/KA97FEASBWXYu0NC6UFor3I1h4hsF5cKSLgO023m5xmHy3LkpZcXJGOwK4/RmnH5sWkdmp9tNlq0m9uJOsruzk8y/r8m4MRgMnP2ZX87FYEPY9ArjbDaNvj94MVKec+7sN8nSjQ/6WZaF+ZLDf1EODfZrucPDQ8Xpc4a4HWetNVcRv6ow6j5HoNHoumkfygNOxxCVq4jduJOqRzBfTRxeqjphBRLCq6mlHben0+n879Ttdh/liPG5nd7OjNnElknTNDwfXMT2ZM/u2xPN/b3+VOHevBkmjCmCKgRrMpmwoLYib/7BGuW1BrsUbe90svtxHH9xljEcDltX5SzA3tfQ392dqTWVAWo7PNjtJEmcXuv2JgYbwsHBi7FdlLLXINqdztIYqhDsdjUtXDeIyXQS2YfygFeHUhvB117UxRAq3xrEXZrN5po3zjydWo2rF5eD9rLLzasE0YnjNNTh0kvgrahRxL3eRmYzD8mrGKoZhX1Xfj6T+FIIlfsGYaetm5q6bpKXU8tqVtHf3ZvZc4n7hFCxQdiZSa/3ce2gTryIwYbw/8V5Z/FikX3x7dm9/UBLdSfzfdk/mzl+C9s6nI/hrhAqi+sOq1o1IB84HYOd45chNH24fLwNnI7Bl/n9tuCqJQQxQDgXQyPUD/J5h1WEUVS49vH6dTg35nbLlb10/immZEN3R+tib6//YMvU28y5GOwiEvcpPA7OGSCIAYIYIIgBghggiAGCGCCIAYIYIIgBghggiAGCGCCIAYIYIIgBghggiAGCGCCIAYIYIIgBghggiAGCGCCIAYIYIIgBghggiAGCGCCIAYIYIIgBghggiAGCGCCIAYIYIIgBghggiAFzeR5OwyQZnCnUnlbpf+Hx8fG0PDycKNRXYc5ev/75TH6cz7t3pz+a0BwGKnipUAvGqIEO1Pujo1cndv8DV7mscE6zIbwAAAAASUVORK5CYII='
var defaultPos = {
  listItemCart: [],

  partyB: {
    phoneNo: null,
    resId: null,
    address: "",
    role: "BUYER",
    displayName: "Khách vãng lai",
    title: "Khách mua",
    otherInfo: {
      avatarUrl: "",
    },
    textShow: ''
  },

  totalAmountCart: 0,
  taxOrder: 0,
  discountOrder: 0,
  ortherService: 0,
  totalOrder: 0,
  payments: 0,
  exchange: 0,
  noteOrder: "",
  checkBoxTaxOrder: 0,
  selectMethodPay: "Tiền mặt",
  selecTypeInput: "%",
  id: 0,
  rm_id: 0,

  paymentInfos: [
    {
      active: false,
      amount: 0,
      note: "Tiền mặt",
      paymentGateway: "CASH",
      paymentMethod: "CASH",
      status: "NOT_PAYMENT",
      imgUrl: require("@/assets/images/Payment_Cash.svg")
    },
  ],

  count: {
    cash: 0,
    tranfer: 0,
    mpos: 0,
    credit: 0,
    debt: 0,
  },
  isDiliveryLast: false,
  dloInfo:{
    note: '',
    //Thong tin goi giao hang
    cod: 0,
    deliveryServicePack: {
      packageInfo: {
        id: null,
        name: null
      },
      partnerCode: null
    },
    //Thong tin goi hang
    packageInfo: {
      heightInCentimeter: 0,
      lengthInCentimeter: 0,
      weightInKilo: 0,
      widthInCentimeter: 0
    },  
    //Dia chi lay hang
    pickUpAddress: {
      address: null,
      city: null,
      cityName: null,
      district: null,
      districtName: null,
      village: null,
      villageName: null,
      lat: null,
      lng: null,
      phoneNo: null
    },
    //Thong tin shipper
    shipperInfo: {
      id: null,
      name: null,
      phoneNo: null,
      text: null
    },
    //Thong tin nhan hang
    shippingAddress: {
      address: null,
      city: null,
      cityName: null,
      district: null,
      districtName: null,
      village: null,
      villageName: null,
      lat: null,
      lng: null,
      phoneNo: null,
      receiverId: null,
      receiverName: null
    },
    shippingFee: 0,//Gia tien don vi van chuyen COD
    addFeesShipping: {
      amount: 0,
      cat: "SHIPPING_FEE",
      key: "SHIPPING_FEE",
      name: "Phí ship báo khách"
    },
    //Shipper rieng hoac qua hang van chuyen:  DELIVERY_PRIVATE_SHIPPER or DELIVERY_PARTNER
    targetService: "DELIVERY_PRIVATE_SHIPPER"
  }
}
var fieldsPos = [
  {
    label: "Sản phẩm",
    key: "itemInstance",
    thStyle: { width: "40%" },
  },
  {
    label: "Đơn vị",
    key: "unit",
    thClass: "text-center",
    tdClass: "text-center",
    thStyle: { width: "10%" },
  },
  {
    label: "Số lượng",
    key: "quantity",
    thClass: "text-center",
    tdClass: "text-center",
    thStyle: { width: "15%" },
  },
  {
    label: "Đơn giá",
    key: "amount",
    thClass: "text-center",
    tdClass: "text-center",
    thStyle: { width: "15%" },
  },
  {
    label: "Thành tiền",
    key: "totalAmount",
    thClass: "text-right",
    tdClass: "text-right",
    thStyle: { width: "10%" },
  },
  {
    label: "",
    key: "deleteItem",
    thClass: "text-center",
    tdClass: "text-center",
    thStyle: { width: "8%"},
  },
]
var dloInfoPos = {
  pickUpAddress: {
    storeName: '',
    address: '',
    city: null,
    cityName: null,
    district: null,
    districtName: null,
    village: null,
    villageName: null,
    lat: null,
    lng: null,
    phoneNo: null
  },
  shippingAddress: {
    address: null,
    city: null,
    cityName: null,
    district: null,
    districtName: null,
    village: null,
    villageName: null,
    lat: null,
    lng: null,
    phoneNo: null,
    receiverId: null,
    receiverName: null
  },
  shipperInfo: {
    id: null,
    name: null,
    phoneNo: null,
    text: null
  },
  shippingFee: 0,
  addFeesShipping: {
    amount: 0,
    cat: "SHIPPING_FEE",
    key: "SHIPPING_FEE",
    name: "Phí ship báo khách"
  },
  targetService: 'DELIVERY_PRIVATE_SHIPPER',
  note: '',
  packageInfo: {
    heightInCentimeter: 0,
    lengthInCentimeter: 0,
    weightInKilo: 0,
    widthInCentimeter: 0
  },
  listPartnerDilivery:[],
  listPackagesDilivery:[],
  cod: 0,
  deliveryServicePack: {
    packageInfo: {
      id: null,
      name: null
    },
    partnerCode: null
  },
  appCode: null,
  appPackage: null
}

//Define popup
import Swal from "sweetalert2"
function showPopupNotNegativeInv(){
  return Swal.fire({
    title: `<span class="text-danger text-bold">Sản phẩm không được bán âm</span>`,
    text: `Sản phẩm này hiện không đủ số lượng trong kho.`,
    icon: "error",
    cancelButtonText: "Quay lại",
    showCancelButton: true,
    showConfirmButton: false,
    backdrop: true,
    allowOutsideClick: false,
  })
}
function showPopupFail(val) {
  return Swal.fire({
    title: `Lỗi (${val}) `,
    html: "Vui lòng thử lại sau",
    confirmButtonColor: "#34c38f",
    confirmButtonText: "Xác nhận",
    imageUrl: require("@/assets/images/exclamation-triangle.svg"),
    imageWidth: 125,
    imageHeight: 125,
    backdrop: true,
    allowOutsideClick: false,
  });
}
function showPopupSuccess(val){
  return Swal.fire({
    title: '<a style="color:#3e69f6; font-size:20px">Thành công</a>',
    html: `<span style="color:#9093A4; font-size: 14px;" >${val} thành công</span>`,
    confirmButtonText: "Xác nhận",
    backdrop: true,
    allowOutsideClick: false,
  })
}
function showPopupDeleteItemFromCart(){
  return Swal.fire({
    title: "Xoá sản phẩm",
    html:
      "Bạn muốn xóa sản phẩm đã chọn " +
      " <br> " +
      " khỏi giỏ hàng không ?",
    confirmButtonColor: "#34c38f",
    confirmButtonText: "Xác nhận",
    cancelButtonColor: "#d33",
    cancelButtonText: "Huỷ",
    imageUrl: require("@/assets/images/exclamation-triangle.svg"),
    showCancelButton: true,
    imageWidth: 125,
    imageHeight: 125,
    backdrop: true,
    allowOutsideClick: false,
  })
}
function showPopupAllowedMinus(){
  return Swal.fire({
    title: `<span class="text-warning text-bold">Bán vượt quá số tồn kho</span>`,
    text: `Sản phẩm này hiện không đủ số lượng trong kho. Bạn vẫn muốn bán chứ ?`,
    icon: "warning",
    confirmButtonText: "Tiếp tục bán",
    cancelButtonText: "Quay lại",
    showCancelButton: true,
    reverseButtons: true,
    backdrop: true,
    allowOutsideClick: false,
  })
}
function showPopupAddNewPosMaxLimit(){
  return Swal.fire({
    title: "Thông báo",
    html: "Số lượng đơn hàng lưu trữ đạt giới hạn, vui lòng thanh toán đơn cũ!",
    confirmButtonColor: "#34c38f",
    confirmButtonText: "Xác nhận",
    imageUrl: require("@/assets/images/exclamation-triangle.svg"),
    imageWidth: 125,
    imageHeight: 125,
  })
}
function showPopupAddNewPosNotItem(resulCheck){
  return Swal.fire({
    title: "Thông báo",
    html: `Đơn hàng ${resulCheck + 1} chưa có sản phẩm, không thể tạo đơn hàng mới!`,
    confirmButtonColor: "#34c38f",
    confirmButtonText: "Xác nhận",
    imageUrl: require("@/assets/images/exclamation-triangle.svg"),
    imageWidth: 125,
    imageHeight: 125,
  })
}
function showPopupDeletePosConfirmDelete(){
  return Swal.fire({
    title: "Thông báo",
    html: "Mọi thông tin đơn sẽ không được lưu lại nếu bạn xóa. Bạn chắc chứ?",
    confirmButtonColor: "#34c38f",
    confirmButtonText: "Lưu đơn nháp",
    cancelButtonColor: "#d33",
    cancelButtonText: "Đồng ý",
    imageUrl: require("@/assets/images/exclamation-triangle.svg"),
    showCancelButton: true,
    imageWidth: 125,
    imageHeight: 125,
  })
}
function showPopupDeletePosSuccess(){
  return Swal.fire({
    icon: "success",
    title:
      '<a style="color:#3e69f6; font-size:20px">Thành công</a>',
    html: `<span style="color:#9093A4; font-size: 14px;"> Xoá đơn hàng thành công</span>`,
    confirmButtonText: "Xác nhận",
  })
}
function showPopupDeletePosNotItem(){
  return Swal.fire({
    title: "Thông báo",
    html: "Giỏ hàng chưa có sản phẩm nào!",
    confirmButtonColor: "#34c38f",
    confirmButtonText: "Xác nhận",
    imageUrl: require("@/assets/images/exclamation-triangle.svg"),
    imageWidth: 125,
    imageHeight: 125,
  })
}
function showPopupDeletePosDefault(){
  return Swal.fire({
    title: "Thông báo",
    html: "Đơn hàng là mặc định, không thể xoá",
    confirmButtonColor: "#34c38f",
    confirmButtonText: "Xác nhận",
    imageUrl: require("@/assets/images/exclamation-triangle.svg"),
    imageWidth: 125,
    imageHeight: 125
  })
}
function showPopupCreatePosPaymenSuccess(dataRes){
  return Swal.fire({
    icon: "success",
    title:
      '<a style="color:#3e69f6; font-size:20px; font-family:BeVietnam">Thành công</<a>',
    html: `<span style="color:#9093A4; font-size: 14px;" >Tạo đơn hàng ${dataRes.data.orderNo} thành công</span>`,
    confirmButtonText: "Tiếp tục bán hàng",
    cancelButtonText: "In hóa đơn",
    showCancelButton: true,
    reverseButtons: true,
    backdrop: true,
    allowOutsideClick: false,
  })
}
function showMessAddNewItemToCart(value, _this) {
  if (value === "Thêm mới") {
    _this.$bvToast.toast(`Thêm sản phẩm vào đơn thành công!`, {
      title: `Thông báo`,
      autoHideDelay: `1000`,
      variant: `success`,
      toaster: `b-toaster-bottom-right`,
      solid: true,
      appendToast: true,
    });
  } else if (value === "Tăng số lượng") {
    _this.$bvToast.toast(`Tăng số lượng sản phẩm trong đơn thành công!`, {
      title: `Thông báo`,
      autoHideDelay: `1000`,
      variant: `success`,
      toaster: `b-toaster-bottom-right`,
      solid: true,
      appendToast: true,
    });
  }
}
function showPopupWarningSeri(){
  return Swal.fire({
    title: `<span class="text-danger text-bold">Sản phẩm không được bán vượt quá số tồn kho</span>`,
    text: `Vui lòng nhập kho EMEI/se-ri cho sản phẩm này.`,
    icon: "error",
    cancelButtonText: "Quay lại",
    showCancelButton: true,
    showConfirmButton: false,
    backdrop: true,
    allowOutsideClick: false,
  })
}
function showPopupPayMentErrors(){
  return Swal.fire({
    title: `<span class="text-danger text-bold">Thanh toán lỗi</span>`,
    text: `Vui lòng kiểm tra lại thông tin cài đặt thanh toán.`,
    icon: "error",
    cancelButtonText: "Quay lại",
    showCancelButton: true,
    showConfirmButton: false,
    backdrop: true,
    allowOutsideClick: false,
  })
}
function showPopupAlertPartyB(){
  return Swal.fire({
    title: `<span class="text-warning text-bold">Thiếu thông tin công nợ</span>`,
    text: `Khách hàng vãng lai không thể ghi công nợ . Vui lòng bổ sung đầy đủ thông tin khách hàng để thực hiện thanh toán.`,
    icon: "warning",
    confirmButtonText: "Thêm khách hàng",
    cancelButtonText: "Quay lại",
    showCancelButton: true,
    reverseButtons: true,
    backdrop: true,
    allowOutsideClick: false,
  })
}
function showPopupPayMpos(){
  return Swal.fire({
    title: `Thất bại`,
    text: `Thanh toán MPOS thất bại`,
    icon: "warning",
    confirmButtonText: "Xác nhận",
    backdrop: true,
    allowOutsideClick: false,
  })
}
function showPopupDebt(){
  return Swal.fire({
    title: `Xác nhận công nợ`,
    text: `Số tiền khách đưa nhỏ hơn số tiền khách phải trả. Hệ thống sẽ tiến hành ghi nợ cho khách hàng`,
    confirmButtonText: "Xác nhận",
    cancelButtonText: "Hủy",
    showCancelButton: true,
    reverseButtons: true,
    backdrop: true,
    allowOutsideClick: false,
  })
}
function showPopupWarningBatch(){
  return Swal.fire({
    title: `<span class="text-danger text-bold">Sản phẩm không được bán vượt quá số tồn kho</span>`,
    text: `Vui lòng nhập kho Lô cho sản phẩm này.`,
    icon: "error",
    cancelButtonText: "Quay lại",
    showCancelButton: true,
    showConfirmButton: false,
    backdrop: true,
    allowOutsideClick: false,
  })
}
function showMessAddKeyPrints(_this) {
  _this.$bvToast.toast(`Thêm từ khóa vào mẫu in thành công!`, {
    title: `Thông báo`,
    autoHideDelay: `1000`,
    variant: `success`,
    toaster: `b-toaster-bottom-right`,
    solid: true,
    appendToast: true,
  });
}
function showMessPrints(_this) {
  _this.$bvToast.toast(`Khởi tạo hóa đơn lỗi!`, {
    title: `Thông báo`,
    autoHideDelay: `1000`,
    variant: `success`,
    toaster: `b-toaster-bottom-right`,
    solid: true,
    appendToast: true,
  });
}
function showMessLessBatch(_this) {
  _this.$bvToast.toast(`Tổng số lượng trong Lô/Hsd đang lớn hơn số lượng bán!`, {
    title: `Thông báo`,
    autoHideDelay: `1000`,
    variant: `danger`,
    toaster: `b-toaster-bottom-right`,
    solid: true,
    appendToast: true,
  });
}
function showMessErrorsShipp(_this) {
  _this.$bvToast.toast(`Vui lòng nhập đủ thông tin địa chỉ giao hàng và phương thức giao hàng!`, {
    title: `Thông báo`,
    autoHideDelay: `1000`,
    variant: `danger`,
    toaster: `b-toaster-top-right`,
    solid: true,
    appendToast: true,
  });
}
function showMessErrorsCustomer(_this) {
  _this.$bvToast.toast(`Vui lòng thêm khách hàng vào đơn!`, {
    title: `Thông báo`,
    autoHideDelay: `1000`,
    variant: `danger`,
    toaster: `b-toaster-top-right`,
    solid: true,
    appendToast: true,
  });
}
function showMessErrorsCheckBoxPackage(_this) {
  _this.$bvToast.toast(`Vui lòng nhập đủ thông tin địa chỉ giao hàng!`, {
    title: `Thông báo`,
    autoHideDelay: `1000`,
    variant: `danger`,
    toaster: `b-toaster-top-right`,
    solid: true,
    appendToast: true,
  });
}
function showMessErrorsResponse(_this, mess) {
  _this.$bvToast.toast(mess, {
    title: `Thông báo`,
    autoHideDelay: `1000`,
    variant: `danger`,
    toaster: `b-toaster-top-right`,
    solid: true,
    appendToast: true,
  });
}
function showMessErrorsPaymentOver(_this) {
  _this.$bvToast.toast(`Phương thức thanh toán này không được vượt quá số tiền còn lại cần trả.!`, {
    title: `Vượt quá số tiền cần trả`,
    autoHideDelay: `1000`,
    variant: `danger`,
    toaster: `b-toaster-top-right`,
    solid: true,
    appendToast: true,
  });
}

function showMessErrorsFocus(_this, title, mess) {
  _this.$bvToast.toast(mess, {
    title: title,
    autoHideDelay: `1000`,
    variant: `danger`,
    toaster: `b-toaster-top-right`,
    solid: true,
    appendToast: true,
  });
}

function showMessOne(_this, title, mess, icon) {
  _this.$bvToast.toast(mess, {
    title: title,
    autoHideDelay: `1000`,
    variant: icon,
    toaster: `b-toaster-top-right`,
    solid: true,
    appendToast: true,
  });
}

export { defaultPos, defaultImg, fieldsPos, dloInfoPos,
  showPopupNotNegativeInv, showPopupFail, showPopupSuccess, showPopupDeleteItemFromCart, 
  showPopupAllowedMinus, showPopupAddNewPosMaxLimit, showPopupAddNewPosNotItem, 
  showPopupDeletePosConfirmDelete, showPopupDeletePosSuccess, showPopupDeletePosNotItem,
  showPopupDeletePosDefault, showPopupCreatePosPaymenSuccess, showMessAddNewItemToCart,
  showPopupWarningSeri, showPopupPayMentErrors, showPopupAlertPartyB, showPopupPayMpos, showPopupDebt, 
  showPopupWarningBatch, showMessAddKeyPrints, showMessPrints,showMessLessBatch, showMessErrorsShipp, showMessErrorsCustomer,
  showMessErrorsCheckBoxPackage, showMessErrorsResponse, showMessErrorsPaymentOver, showMessErrorsFocus, showMessOne
}